export const ActivityFeed = () => {
    // Disabled to prevent dummy notifications.
    // If real notification functionality is added, the logic can be restored here.
    return null;
};
